import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiLineItems } from "~/routes"

import PageContainer from "~/library/PageContainer"
import LineItemForm from "~/components/LineItemForm"

const NewLineItem = () => {
  const { venueSlug } = getAppConfig()
  const [createdLineItemId, setCreatedLineItemId] = useState<string | null>(null)
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      line_item: formValues,
    }

    apiLineItems
      .create({ data })
      .then(({ lineItem }) => {
        setCreatedLineItemId(lineItem.id)
        toast("Line item created successfully", "success")
      })
      .catch((res) => {
        toast(res.body?.errors?.join(", ") || "Please try again", "danger")
      })
  }

  if (createdLineItemId) {
    return <Navigate to={`/line-items/${createdLineItemId}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">New Line Item</h3>
          <LineItemForm venueSlug={venueSlug} onSubmit={handleSubmit} />
        </div>
      </div>
    </PageContainer>
  )
}

export default NewLineItem
